import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Platform scrollbar rule (thin, no track, no arrows) + Infinity tint.
import 'shared/scrollbars.css';
import './styles/scrollbarTheme.css';
import App from './App';
// import { AuthProvider } from './contexts/AuthContext';
import { AuthProvider, useAuth } from './contexts/KeycloakAuthContext';
import { SignInIntroGate, SignInIntroReady } from 'shared/signin/signInIntro';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';

document.title = '24K.Infinity';

// The branded start-up intro (INFINITY drawn letter by letter, Jean, 30 Oct 2026) sits above the
// auth provider, which waits for it before keycloak-js sends the page to the sign-in page.
// The signed-out page shows at once, with no intro.
const signedOutPage = /^\/signed-out\/?$/.test(window.location.pathname);

function IntroReady() {
  const { loading } = useAuth();
  return <SignInIntroReady when={!loading} />;
}

function ThemedToastContainer() {
  const { mode } = useTheme();
  return <ToastContainer position="top-right" theme={mode} autoClose={4000} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <ThemeProvider>
      <SignInIntroGate product="infinity" subtitle="PROVIDER CONTROL PLANE" enabled={!signedOutPage}>
        <AuthProvider>
          <IntroReady />
          <App />
          <ThemedToastContainer />
        </AuthProvider>
      </SignInIntroGate>
    </ThemeProvider>
  </BrowserRouter>
);
